<template>
  <div class="list-tags">
    <ion-grid>
    <ion-row>

      <ion-col size="12" size-sm="3" v-for="tag in allTags"
               :key="tag.id">
        <ion-card>
          <ion-card-header>
            <ion-card-title> {{ tag.title }} <ion-icon name="trash" @click="runDeleteTag(tag)"/></ion-card-title>

          </ion-card-header>
          <ion-card-content v-if="tag.childs.length > 0">

            <ul>
              <li v-for="child in tag.childs" v-bind:key="child.id" >{{ child.title }}
                <ion-icon name="trash" @click="runDeleteTag(child)"/>
                <ul v-if="child.childs">
                  <li v-for="childChild in child.childs" v-bind:key="childChild.id" >{{ childChild.title }}
                    <ion-icon name="trash" @click="deleteTag(childChild)" />
                  </li>
                </ul>
              </li>
            </ul>
          </ion-card-content>
        </ion-card>
      </ion-col>

    </ion-row>
    </ion-grid>




  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ListTags",
  methods: {
    ...mapActions(["getTags", "deleteTag"]),
    runDeleteTag(tag) {
      this.deleteTag(tag);
    }
  },
  computed: mapGetters(["allTags"]),
  created() {
    this.getTags();
  }
};
</script>

<style scoped>

  .list-tags {
   margin-top: 30px;

  }

  ion-icon {
    float: right;
  }

</style>
